// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_j6-0";